import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlus, ClipboardCheck, Link2 } from 'lucide-react';

// Portada de la gestión: los tres apartados en uso.
export default function AdminHome() {
  return (
    <div>
      <div className="page-header">
        <h1>Gestión</h1>
        <p>Elige el apartado con el que quieres trabajar</p>
      </div>
      <div className="main-buttons-grid">
        <Link to="/gestion/solicitudes" className="main-button main-button--onboarding animate-in">
          <div className="main-button__icon"><UserPlus size={44} /></div>
          <div className="main-button__text">
            <h3>Nuevos Empleados</h3>
            <p>Altas en proceso y finalizadas</p>
          </div>
        </Link>
        <Link to="/gestion/onboarding" className="main-button main-button--sae animate-in">
          <div className="main-button__icon"><ClipboardCheck size={44} /></div>
          <div className="main-button__text">
            <h3>Docs. Onboarding</h3>
            <p>Documentos que descargan y firman los nuevos empleados</p>
          </div>
        </Link>
        <Link to="/gestion/enlaces" className="main-button main-button--links animate-in">
          <div className="main-button__icon"><Link2 size={44} /></div>
          <div className="main-button__text">
            <h3>Enlaces</h3>
            <p>Repositorio de enlaces y formulario de vacaciones</p>
          </div>
        </Link>
      </div>
    </div>
  );
}
